import { createFileRoute } from '@tanstack/react-router';
import { MessagesPage } from '../../features/messaging';

export const Route = createFileRoute('/portal/messages/')({
  validateSearch: (search: Record<string, unknown>): { with?: string } =>
    typeof search.with === 'string' ? { with: search.with } : {},
  component: function MessagesRoute() {
    const { with: withOrg } = Route.useSearch();
    return <MessagesPage withOrg={withOrg ?? null} />;
  },
});
